import { distance, closest } from 'fastest-levenshtein'

export function fuzzySearch(value, list) {
    const searchValueLower = value.toLowerCase().trim()

    if (searchValueLower == '')
        return list

    let scoredEntitiesList = []

    const searchComponents = searchValueLower.split(' ')

    for (let i = 0; i < list.length; i++) {
        let score = 0
        const u = list[i]

        // Name Value Checker
        const entityNameLower = u.firstname.toLowerCase() + ' ' + u.lastname.toLowerCase() // Convert name to lower case

        // Entire name First + Last name
        let lowestDifference = distance(entityNameLower, searchValueLower) / entityNameLower.length // The similarity score assigned

        // Break down name into first name and last name componenets
        const nameComponents = [u.firstname.toLowerCase(), u.lastname.toLowerCase()]

        for (let k = 0; k < searchComponents.length && k < 4; k++) {
            let maxScore = -10000
            for (let j = 0; j < nameComponents.length; j++) {
                const nameComponent = nameComponents[j]
                let s = 0
                
                if (searchValueLower.length && nameComponent.startsWith(searchComponents[k])) // If there is an exact match starting phrase give points instantly
                    s += 0.8
                
                // Check the similarity as a comparision between each name component
                const distanceValue = distance(nameComponent, searchComponents[k]) / nameComponent.length

                s += 1 - distanceValue

                s -= 0.2*k // Search by first name fisrt

                // If give the assigned score based on if the name matches well
                if (s > maxScore)
                    maxScore = s
            }
            score += maxScore
        }
            
        scoredEntitiesList.push({ item: u, score: score })
    }

    scoredEntitiesList.sort((entity1, entity2) => {
        if (entity1.score < entity2.score)
            return 1
        else if (entity1.score > entity2.score)
            return -1
        return 0
    })

    return scoredEntitiesList
        // .slice(0, 10)
        .filter((item, index) => (item.score > 0.4 && item.score >= scoredEntitiesList[0].score * 0.7))
        .map((item) => item.item)

}
